/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSupplierPackagingsVisibilityMutationVariables = Exact<{
  supplierCompanyId: string;
}>;


export type UpdateSupplierPackagingsVisibilityMutation = { updateSupplierPackagingsVisibility: { success: boolean } | null };


export const UpdateSupplierPackagingsVisibilityDocument = /*#__PURE__*/ gql`
    mutation UpdateSupplierPackagingsVisibility($supplierCompanyId: uuid!) {
  updateSupplierPackagingsVisibility(supplierCompanyId: $supplierCompanyId) {
    success
  }
}
    `;
export type UpdateSupplierPackagingsVisibilityMutationFn = Apollo.MutationFunction<UpdateSupplierPackagingsVisibilityMutation, UpdateSupplierPackagingsVisibilityMutationVariables>;

/**
 * __useUpdateSupplierPackagingsVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierPackagingsVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierPackagingsVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierPackagingsVisibilityMutation, { data, loading, error }] = useUpdateSupplierPackagingsVisibilityMutation({
 *   variables: {
 *      supplierCompanyId: // value for 'supplierCompanyId'
 *   },
 * });
 */
export function useUpdateSupplierPackagingsVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierPackagingsVisibilityMutation, UpdateSupplierPackagingsVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierPackagingsVisibilityMutation, UpdateSupplierPackagingsVisibilityMutationVariables>(UpdateSupplierPackagingsVisibilityDocument, options);
      }
export type UpdateSupplierPackagingsVisibilityMutationHookResult = ReturnType<typeof useUpdateSupplierPackagingsVisibilityMutation>;
export type UpdateSupplierPackagingsVisibilityMutationResult = Apollo.MutationResult<UpdateSupplierPackagingsVisibilityMutation>;
export type UpdateSupplierPackagingsVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierPackagingsVisibilityMutation, UpdateSupplierPackagingsVisibilityMutationVariables>;